import { HStack, Spacer } from '@chakra-ui/react'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@app/components/ui/button'

interface Props {
  showFooter?: boolean
  disabled?: boolean
}

const WelcomeFooter: FC<Props> = ({ showFooter = true, disabled = false }) => {
  if (!showFooter) {
    return null
  }

  const skipLink = '/maps'

  return (
    <HStack gap={2} w="full">
      {disabled && (
        <Button color="blue.500" variant="plain" asChild>
          <Link to={skipLink}>Skip</Link>
        </Button>
      )}
      <Spacer />
      <Button variant="outline" disabled={disabled} asChild>
        <Link to={skipLink}>Continue</Link>
      </Button>
    </HStack>
  )
}

export default WelcomeFooter
